import { useMemo } from 'react';

import { useGetWidgetState } from '@swf/poker';

const useGetCurrentClub = (clubId: string) => {
  const { clubs } = useGetWidgetState();
  const club = useMemo(
    () => clubs.find((clubItem) => clubItem.clubId === Number(clubId)) ?? {},
    [clubs, clubId]
  );

  return club;
};

export default useGetCurrentClub;
